import React from 'react';
import { getTestIds } from '../../utils/TestIds';
export const GetFullPageModalHeaderActionsTID = (parentTestId)=>getTestIds(parentTestId);
export const isHeaderActionItem = (v)=>typeof v === 'object' && v !== null && 'text' in v && 'icon' in v && 'onClick' in v;
